import { AjaxService } from './Ajax.service';

// API services
import AdminService from './Admin.service';
import AuthService from './Auth.service';
import BoxService from './Box.service';
import CartService from './Cart.service';
import CatalogService from './Catalog.service';
import CheckoutService from './Checkout.service';
import ConfigService from './Config.service';
import ContactService from './Contact.service';
import CSRService from './CSR.service';
import CustomerLoyaltyService from './CustomerLoyalty.service';
import CustomizationService from './Customization.service';
import DatalayerService from './Datalayer.service';
import EspotService from './Espot.service';
import ExproService from './Expro.service';
import ExproOrderService from './ExproOrder.service';
import ExternalService from './External.service';
import GooglePlacesService from './GooglePlaces.service';
import HipayService from './Hipay.service';
import HipayExproServices from './HipayExpro.service';
import HomepageLayoutService from './Homepagelayout.service';
import NewsletterService from './Newsletter.service';
import NotebookService from './Notebook.service';
import OrderService from './Order.service';
import PhoneValidatorService from './PhoneValidator.service';
import PreviewService from './Preview.service';
import PrimeurService from './Primeur.service';
import ProductsService from './Products.service';
import PromotionService, { FakePromotionService } from './Promotion.service';
import SeoService from './Seo.service';
import ShippingService from './Shipping.service';
import SlideService from './Slide.service';
import StorageService from './Storage.service';
import StoreService from './Store.service';
import UserService from './User.service';
import WishListService from './WishList.service';
import BentoService from '@/services/Bento.service';

// Static services
export * from './Logger.service';

// Parent service
export * from './Ajax.service';

export class ApiServices {
  readonly adminService: AdminService;
  readonly authService: AuthService;
  readonly bentoService: BentoService;
  readonly boxService: BoxService;
  readonly cartService: CartService;
  readonly catalogService: CatalogService;
  readonly checkoutService: CheckoutService;
  readonly configService: ConfigService;
  readonly contactService: ContactService;
  readonly csrService: CSRService;
  readonly customerLoyaltyService: CustomerLoyaltyService;
  readonly customizationService: CustomizationService;
  readonly datalayerService: DatalayerService;
  readonly espotService: EspotService;
  readonly exproService: ExproService;
  readonly exproOrderService: ExproOrderService;
  readonly externalService: ExternalService;
  readonly googlePlacesService: GooglePlacesService;
  readonly hipayService: HipayService;
  readonly hipayExproService: HipayExproServices;
  readonly homepageLayoutService: HomepageLayoutService;
  readonly newsletterService: NewsletterService;
  readonly notebookService: NotebookService;
  readonly orderService: OrderService;
  readonly phoneValidatorService: PhoneValidatorService;
  readonly previewService: PreviewService;
  readonly primeurService: PrimeurService;
  readonly productsService: ProductsService;
  readonly promotionService: PromotionService;
  readonly seoService: SeoService;
  readonly shippingService: ShippingService;
  readonly slideService: SlideService;
  readonly storageService: StorageService;
  readonly storeService: StoreService;
  readonly userService: UserService;
  readonly wishListService: WishListService;

  constructor(ajaxService: AjaxService) {
    this.adminService = new AdminService(ajaxService);
    this.authService = new AuthService(ajaxService);
    this.bentoService = new BentoService(ajaxService);
    this.boxService = new BoxService(ajaxService);
    this.cartService = new CartService(ajaxService);
    this.catalogService = new CatalogService(ajaxService);
    this.checkoutService = new CheckoutService(ajaxService);
    this.configService = new ConfigService(ajaxService);
    this.contactService = new ContactService(ajaxService);
    this.csrService = new CSRService(ajaxService);
    this.customerLoyaltyService = new CustomerLoyaltyService(ajaxService);
    this.customizationService = new CustomizationService(ajaxService);
    this.datalayerService = new DatalayerService();
    this.espotService = new EspotService(ajaxService);
    this.exproService = new ExproService(ajaxService);
    this.exproOrderService = new ExproOrderService(ajaxService);
    this.externalService = new ExternalService(ajaxService);
    this.googlePlacesService = new GooglePlacesService(ajaxService);
    this.hipayService = new HipayService(ajaxService);
    this.hipayExproService = new HipayExproServices(ajaxService);
    this.homepageLayoutService = new HomepageLayoutService(ajaxService);
    this.newsletterService = new NewsletterService(ajaxService);
    this.notebookService = new NotebookService(ajaxService);
    this.orderService = new OrderService(ajaxService);
    this.phoneValidatorService = new PhoneValidatorService(ajaxService);
    this.previewService = new PreviewService(ajaxService);
    this.primeurService = new PrimeurService(ajaxService);
    this.productsService = new ProductsService(ajaxService);
    this.promotionService = new PromotionService(ajaxService);
    this.seoService = new SeoService(ajaxService);
    this.shippingService = new ShippingService(ajaxService);
    this.slideService = new SlideService(ajaxService);
    this.storageService = new StorageService(ajaxService);
    this.storeService = new StoreService(ajaxService);
    this.userService = new UserService(ajaxService);
    this.wishListService = new WishListService(ajaxService);
  }
}

export class FakeApiServices {
  readonly promotionService: FakePromotionService;
  constructor() {
    this.promotionService = new FakePromotionService();
  }
}
